import React from 'react';

export default function AppConnection() {

    return (
        <div>
            <p>Accounts</p>
        </div>
    );
};
